import Formsy from 'formsy-react'
import { priceDisplay } from 'helpers/price';
import React, { Component } from 'react'
import { Container, Dropdown, Grid, Header, Pagination, Segment, Tab, Table, Button, Icon ,Modal, Dimmer, Loader, Transition, Message} from 'semantic-ui-react';
import { getCategoryList } from 'services/Categories';
import { getMarkets, getFailedCommissionPaymentsList ,isSubscriptionSearchEnabled} from 'services/Manager';
import { getSubscriptionStatus } from 'services/SellerSubscription';
import moment from 'moment';
import './FailedCommissionPayments.less'
import GoogleMapReact from 'google-map-react';
import Config from 'Config';
import Marker from '../../components/GMaps/Marker';
import { IN_TRIAL } from 'constants/SellerSubscriptionStatus';
import DGTextarea from 'components/FormControls/Textarea/DGTextarea';
import { saveSellerDetail } from 'services/Seller';

const rowsPerPage = 20;

const initialState = {
    categories: [],
    // subStatus: [],
    markets: [],
    marketListOriginal: [],
    currentCategoryValue: '',
    currentCategoryText: '',
    // currentStatusValue: '',
    //currentStatusText: '',
    currentMarketValue: '',
    currentMarketText: '',
    page: 1,
    commissionPaymentListCount:0,
    commissionPaymentList: [],
    subscriptionListForMap: [],
    pageChange: false,
    showMap: false,
    //mapCenter:{lat: 39.8097343, lng: -98.5556199},
    zoomLevel: 1,
    subscriptionSearchEnabled:false,
    notes: '',
    savingNotes: false,
    currentSellerID: 0,
    currentSellerName: '',
    notesModalOpen: false,
    notesMessage: '',
    notesMessageSuccess: true,
    showNotesMessage: false,
};

class FailedCommissionPayments extends Component {

    static defaultProps = {
        USCenter: {
            lat: 39.8097343, 
            lng: -98.5556199
        },
        zoom: 1
      };

    constructor(props){
        super(props);
        this.state = initialState;
    }

    componentDidMount(){
        // const subStatusPromise = getSubscriptionStatus();
        const categoryPromoise = getCategoryList();
        const marketPromise = getMarkets();
        const subsSearchPromise =  isSubscriptionSearchEnabled();

        Promise.all([
            //subStatusPromise,
             categoryPromoise, marketPromise, subsSearchPromise]).then(([
                 //subStatusRes, 
                 categoryRes, marketRes,subsSearchRes]) => {
            const categoryList = this.populateCategories(categoryRes.data);
            // const statusList = this.populateSubscriptionStatus(subStatusRes.data);
            const marketList = this.populateMarkets(marketRes.data);

            this.setState({
                categories: categoryList, 
                currentCategoryText: 'All Categories', 
                currentCategoryValue: '',
                //subStatus: statusList, 
                //currentStatusText: 'Active', 
                //currentStatusValue: 'Active',
                markets: marketList, 
                marketListOriginal: marketRes.data,
                currentMarketText: 'Any Market', 
                currentMarketValue: '',
                subscriptionSearchEnabled: subsSearchRes.data.enabled
            }, () => {
                this.onSearch();
            });
        });
    }

    populateCategories = (categories) => {
        let categoryList = _.map(categories, cat => {
            return {value: cat.seoName, text: cat.name}
        });

        categoryList = [{value: '', text: 'All Categories'}, ...categoryList];
        return categoryList;
    }

    // populateSubscriptionStatus = (status) => {

    //     status = _.filter(status, st => st.name != 'Suspended' && st.name != 'Cancelled')
    //     let statusList = _.map(status, st => {
    //         return {value: st.name, text: st.name}
    //     });

    //     statusList = [{value: '', text: 'Any Status'}, ...statusList];
    //     return statusList;
    // }

    populateMarkets = (markets) => {
        let marketList = _.map(markets, market => {
            return {value: market.marketID, text: market.name}
        });

        marketList = [{value: '', text: 'Any Market'}, ...marketList];
        return marketList;
    }

    onCategoryChange = (e, data) => {
        const selectedCategory = _.first(_.filter(this.state.categories, item => item.value == data.value));
        this.setState({currentCategoryValue: selectedCategory.value, currentCategoryText: selectedCategory.text})
    }

    // onStatusChange = (e, data) => {
    //     const selectedStatus = _.first(_.filter(this.state.subStatus, item => item.value == data.value));
    //     this.setState({currentStatusValue: selectedStatus.value, currentStatusText: selectedStatus.text})
    // }

    onMarketChange = (e, data) => {
        const selectedMarket = _.first(_.filter(this.state.markets, item => item.value == data.value));
        this.setState({currentMarketValue: selectedMarket.value, currentMarketText: selectedMarket.text})
    }

    onSearch = async (e, data) => {
        this.search();
    }

    search = async () => {

        const subscriptionListRes = await getFailedCommissionPaymentsList(this.state.page, rowsPerPage, this.state.currentCategoryValue, this.state.currentMarketValue);
        
        this.setState({commissionPaymentList: subscriptionListRes.data.failedPaymentsList, commissionPaymentListCount: subscriptionListRes.data.failedPaymentsCount});
        

        this.setState({pageChange: false});
    }

    onPageChange = (e, data) => {
        this.setState({page: data.activePage, pageChange: true}, () => {
            this.search();
        });       
    }

    // onShowMapClick = () => {
    //     this.setState({showMap: true});
    // }
    onShowGridClick = () => {
        this.setState({showMap: false});
    }

    createMapOptions = (maps) => {
        return {
          fullscreenControl: false,
        }
      }

      handleSellerNameClick = (sellerID) => {
        const win = window.open('/subscriptions/search/' + sellerID, "_blank");
        win.focus();
      }

    onNotesModalClose = () => {
        this.setState({ notesModalOpen: false })
    }
    
    onNotesChange = (e, data) => {
        this.setState({ notes: data.value });
    }

    onValidFailedCommissionPaymentNotesSave = async (e, data) => {
        this.setState({ savingNotes: true, showNotesMessage: false, notesMessage: '' });
        const notes = this.state.notes;

        const saveResponse = await saveSellerDetail(this.state.currentSellerID, { failedCommissionPaymentNotes : notes});

        if (saveResponse.resStatus == 200) {
            this.setState({ currentSellerID: 0, currentSellerName: '', notesModalOpen: false, savingNotes: false, notes: '', showNotesMessage: false, notesMessage: '' });
            this.onSearch();
        }
        else {
            this.setState({ showNotesMessage: true, notesMessage: 'Error saving this information', notesMessageSuccess: false, savingNotes: false });
        }
    }

    onNotesClick = (sellerID, sellerName, failedCommissionPaymentNotes) => {
        this.setState({ currentSellerID: sellerID, currentSellerName: sellerName, notesModalOpen: true, notes: failedCommissionPaymentNotes });
    }

    render() {
        return (
            <Container fluid className="faild-commission-payments-container">
                <div className="main-page-panel">
                    <div className="content-panel">
                        <div className="mobile-header mobile-header-new ">
                            <div className="main-heading main-heading-new">
                                Failed Commission Payments
                            </div>
                        </div>
                        <Segment className="filter-segment">
                            <Formsy onValidSubmit={this.onSearch}>
                                <Grid>
                                    <Grid.Row>
                                        <Grid.Column width={16}>
                                            <Header>Categories</Header>
                                            <Dropdown fluid name="category" key="act-sub-fil-category" 
                                            selection
                                            options={this.state.categories}
                                            value={this.state.currentCategoryValue}
                                            text={this.state.currentCategoryText}
                                            onChange={this.onCategoryChange}
                                            ></Dropdown>
                                        </Grid.Column>
                                    </Grid.Row>
                                    {/* <Grid.Row>
                                        <Grid.Column width={16}>
                                            <Header>Status</Header>
                                            <Dropdown fluid name="sub-status" key="act-sub-fil-sub-status"
                                            selection
                                            options={this.state.subStatus}
                                            value={this.state.currentStatusValue}
                                            text={this.state.currentStatusText}
                                            onChange={this.onStatusChange}
                                            ></Dropdown>
                                        </Grid.Column>
                                    </Grid.Row> */}
                                    <Grid.Row>
                                        <Grid.Column width={16}>
                                            <Header>Markets</Header>
                                            <Dropdown fluid name="markets" key="act-sub-fil-markets"
                                            selection
                                            options={this.state.markets}
                                            value={this.state.currentMarketValue}
                                            text={this.state.currentMarketText}
                                            onChange={this.onMarketChange}></Dropdown>
                                        </Grid.Column>
                                    </Grid.Row>
                                    <Grid.Row>
                                        <Grid.Column width={16}>
                                            <button className="button-submit">Search</button>
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </Formsy>
                        </Segment>
                        <Button.Group basic size="large" className="button-group">
                            <Button onClick={this.onShowGridClick} className={!this.state.showMap ? 'selected' : ''}>
                                <Icon name="table" />
                                List </Button>
                            {/* <Button onClick={this.onShowMapClick} className={this.state.showMap ? 'selected' : ''}>
                                <Icon name="map" />
                                Map </Button> */}

                        </Button.Group>
                        <Segment className={`content-segment ${this.state.showMap ? 'hidden' : 'visible'}`}>
                            
                            <Container fluid>
                                <Pagination ellipsisItem={null} totalPages={Math.ceil(this.state.commissionPaymentListCount / rowsPerPage)} activePage={this.state.page} onPageChange={this.onPageChange} />
                            </Container>
                            <Table celled striped>
                            
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell>Request</Table.HeaderCell>
                                        <Table.HeaderCell>Business</Table.HeaderCell>
                                        <Table.HeaderCell>Email</Table.HeaderCell>
                                        <Table.HeaderCell>Phone</Table.HeaderCell>
                                        <Table.HeaderCell>Category</Table.HeaderCell>
                                        <Table.HeaderCell>Service</Table.HeaderCell>
                                        <Table.HeaderCell>Price</Table.HeaderCell>
                                        <Table.HeaderCell>Commision %</Table.HeaderCell>
                                        <Table.HeaderCell>Amount</Table.HeaderCell>
                                        <Table.HeaderCell>Accepted on</Table.HeaderCell>
                                        <Table.HeaderCell>Next Payment Date</Table.HeaderCell>
                                        <Table.HeaderCell>Notes</Table.HeaderCell>   
                                    </Table.Row>
                                </Table.Header>
                                <Table.Body>
                                    {
                                        this.state.commissionPaymentList.length > 0 &&
                                        _.map(this.state.commissionPaymentList, sub => {
                                            return <Table.Row>
                                                <Table.Cell>
                                                    {sub.RequestID}
                                                </Table.Cell>
                                                <Table.Cell>
                                                    <span className={`${this.state.subscriptionSearchEnabled ? "seller-business-name" : ""} `} onClick={this.state.subscriptionSearchEnabled ?  () => {this.handleSellerNameClick(sub.sellerID)} : () => {}} >
                                                        {sub.SellerName}
                                                    </span>
                                                </Table.Cell>
                                                <Table.Cell>
                                                    {sub.SellerEmail}
                                                </Table.Cell>
                                                <Table.Cell>
                                                    {sub.SellerPhone}
                                                </Table.Cell>
                                                <Table.Cell>
                                                    {sub.categoryName}
                                                </Table.Cell>
                                                <Table.Cell>
                                                    {sub.serviceName}
                                                </Table.Cell>
                                                <Table.Cell>                                                  
                                                    {sub.bidAmount ? `${priceDisplay(sub.bidAmount)}` : '-'}
                                                </Table.Cell>
                                                <Table.Cell>
                                                    {sub.commission}
                                                </Table.Cell>
                                                <Table.Cell>
                                                    {sub.amount ? `${priceDisplay(sub.amount)}` : '-'}
                                                </Table.Cell>
                                                <Table.Cell>
                                                    {moment(sub.acceptedOn).format('DD MMM YYYY')}
                                                </Table.Cell>
                                                <Table.Cell>
                                                     {sub.nextPaymentDate ? moment(sub.nextPaymentDate).format('DD MMM YYYY') : "-"}
                                                </Table.Cell>
                                                <Table.Cell style={{whiteSpace : "break-spaces"}}>
                                                    {sub.failedCommissionPaymentNotes && _.trim(sub.failedCommissionPaymentNotes).length > 0 ? <div>{sub.failedCommissionPaymentNotes} <Icon name="pencil" style={{color: '#21ba45', cursor: 'pointer'}} size='small' onClick={() => this.onNotesClick(sub.sellerID, sub.SellerName, sub.failedCommissionPaymentNotes)} /></div> : 
                                                    <Icon name="sticky note outline" style={{color: '#21ba45', cursor: 'pointer'}} size='large' onClick={() => this.onNotesClick(sub.sellerID, sub.SellerName, sub.failedCommissionPaymentNotes)} /> }
                                                </Table.Cell>
                                            </Table.Row>
                                        })
                                    }
                                    {
                                        this.state.commissionPaymentList.length == 0 && <Table.Row>
                                            <Table.Cell colspan={16}>
                                                No record found
                                            </Table.Cell>
                                        </Table.Row>
                                    }
                                </Table.Body>
                            </Table>
                            <Container fluid>
                                <Pagination ellipsisItem={null} totalPages={Math.ceil(this.state.commissionPaymentListCount / rowsPerPage)}   activePage={this.state.page} onPageChange={this.onPageChange} />
                            </Container>
                        </Segment>
                    </div>
                </div>

                <Modal className="ap-modal" closeOnDimmerClick={false} closeOnEscape={false} onClose={this.onNotesModalClose} open={this.state.notesModalOpen} closeIcon>
                    <Modal.Header>
                        {this.state.currentSellerName}
                    </Modal.Header>
                    <Dimmer.Dimmable as={Modal.Content} blurring dimmed={this.state.savingNotes}>
                        <Dimmer active={this.state.savingNotes} inverted>
                            <Loader>Saving</Loader>
                        </Dimmer>
                        <Transition visible={this.state.showNotesMessage} animation='fade' duration={500}>
                            <Message {...{
                                success: this.state.notesMessageSuccess,
                                error: !this.state.notesMessageSuccess
                            }}>
                                {this.state.notesMessage}
                            </Message>
                        </Transition>
                        <Formsy onValidSubmit={this.onValidFailedCommissionPaymentNotesSave}>                             
                            <Grid>
                                <Grid.Row>
                                    <Grid.Column width={16}>
                                    <DGTextarea
                                            name="Notes"
                                            value={this.state.notes}
                                            maxLength={512}
                                            label="Failed Commission Payment Notes"
                                            onChange={this.onNotesChange}
                                            required
                                            validationErrors={{
                                                isDefaultRequiredValue: 'This field is required'
                                                
                                            }} />
                                    </Grid.Column>
                                </Grid.Row>
                                <Grid.Row>
                                    <Grid.Column width={16}>
                                        <button className="button-submit">Save</button>
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                        </Formsy>
                    </Dimmer.Dimmable>
                </Modal>
            </Container>
        )
    }
}

export default FailedCommissionPayments
